export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إجمالي المبلغ للخصم"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["العمولة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["معلومات"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["للإضافة"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا يمكن حساب المبلغ"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["رصيد غير كاف لإجراء الدفع"])}
}